import { Link } from "react-router-dom";
import classes from "./ProductList.module.css";
import { useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useState } from "react";

const ProductList = ({ data }) => {
  const checkisLiked = () => {
    if (data.isLiked === "true") {
      return true;
    } else {
      return false;
    }
  };

  const [isLiked, setIsLiked] = useState(checkisLiked);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = searchParams.get("page");

  const likeHandler = () => {
    //TODO:帶token 傳 PUT 修改isLiked property
    //目前先toggle假的
    setIsLiked(!isLiked);
  };

  return (
    <li className={classes.product}>
      <figure className={classes.product__img}>
        <Link to={`${data.id}`}>
          <img src={data.img} alt={`product of ${data.itemName}`} />
        </Link>
      </figure>
      <div className={classes.product__desc}>
        <Link to={`${data.id}`}>
          <span>{data.itemName}</span>
        </Link>
        <Icon
          icon="wpf:like"
          color={`${isLiked ? "var(--red-600)" : "#ced4da"}`}
          width="20"
          height="20"
          className={classes.like}
          onClick={likeHandler}
        />
      </div>
    </li>
  );
};

export default ProductList;
